import React from 'react';
import s from './s.module.less';

interface ProgressIndicatorProps {
    currentStep: number;
    totalSteps: number;
}

export default function ProgressIndicator({ currentStep, totalSteps }: ProgressIndicatorProps) {
    const renderProgressBar = () => {
        const steps = [];
        for (let i = 1; i <= totalSteps; i++) {
            steps.push(
                <div 
                    key={i}
                    className={`${s.progressStep} ${i <= currentStep ? s.active : ''}`}
                />
            );
        }
        return steps;
    };

    return (
        <div className={s.progressSection}>
            <div className={s.progressBar}>
                {renderProgressBar()}
            </div>
            <div className={s.progressText}>
                {currentStep} of {totalSteps}
            </div>
        </div>
    );
}
